import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import MainContainer3 from '../../components/Carousel/MainContainer3';
import BannerArea3 from '../../components/Carousel/BannerArea3';
import ServiceGrid from '../../components/Sections/ServiceGrid';
import GalaPosterModal from '../../components/Servicepages/GalaPosterModal';

// Palette white / beige / gold
const colors = {
  bg: '#FFFFFF',
  goldLight: '#F5E1C8',
  gold: '#C69C6D',
};

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .services-page {
          background: ${colors.bg};
          position: relative;
          overflow: hidden;
        }

        /* Orbes dorées floues en fond */
        .services-page::before,
        .services-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.25;
          z-index: 0;
          pointer-events: none;
        }

        .services-page::before {
          width: 45vw;
          height: 45vw;
          background: ${colors.goldLight};
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .services-page::after {
          width: 35vw;
          height: 35vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .services-content {
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .services-page::before {
            width: 70vw;
            height: 70vw;
          }
          .services-page::after {
            width: 60vw;
            height: 60vw;
          }
        }
      `}</style>

      <motion.div
        className="services-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="services-content">
        
          <Header />
          <BannerArea3 />
          <ServiceGrid />
          <MainContainer3 />
          <Footer />
        
        </div>
      </motion.div>
    </>
  );
};

export default Services;